import { HostBinding, Component, OnInit, Injector, Input, Pipe, PipeTransform } from '@angular/core';
import { EventsComponent } from '../events/events.component';
import {
	filter,
	isEmpty,
	isArray,
	includes,
	uniqueId, // tslint:disable-next-line: component-selector
} from 'lodash';

@Component({
	selector: 'alarm-system',
	template: `
		<div class="round-image-container" [ngClass]="{ disabled: control.disabled }" role="group">
			<div class="round-image-list">
				<round-image
					*ngFor="let option of showOptions"
					[isSelected]="isSelected(option.value)"
					[title]="option.title"
					[selected]="option.value"
					[option]="option"
					[ngClass]="{ disabled: control.disabled, error: error }"
					(ToggleRoundImage)="onToggle(option.value)"
					[control]="control"
					[value]="option.value"
					[parentName]="control.name"
					context="page"
					[setAnswer]="setAnswer"
					id="{{ name | ricName }}"
				>
				</round-image>
			</div>
			<more-button
				class="more-button"
				*ngIf="isShowMoreButton()"
				[options]="control.options"
				[isMoreOpen]="isOpen"
				[selected]="value"
				title="None"
				mode="{{ mode }}"
				[ngClass]="{ disabled: control.disabled, error: error }"
				(isOpen)="isHiddenOpen()"
				[isDisabled]="control.disabled"
				[arrOffset]="maxNumOfOptions"
			>
			</more-button>
		</div>
	`,
	styleUrls: ['./alarm-system.component.scss'],
})
export class AlarmSystemComponent extends EventsComponent implements OnInit {
	mode: any;
	error: any;
	radio: any;
	multi: any;
	isOpen: boolean;
	maxNumOfOptions: number;
	showOptions: any;
	hiddenOptions: any;
	noneValue: string;
	BP = {
		1: 400,
		3: 750,
		4: 850,
	};
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	constructor(injector: Injector) {
		super(injector);
		this.multi = 'multi';
		this.noneValue = 'None';
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
		}
		this.mode = this.getMode();
		this.maxNumOfOptions = this.calcMaxNumOfOptions();
		this.hiddenOptions = this.getHiddenOptions();
		this.showOptions = this.control.options.slice(0, this.maxNumOfOptions);

		if (!isEmpty(this.value) && includes(this.value, this.noneValue)) {
			this.setAnswer([this.noneValue]);
			this.value = [this.noneValue];
			this.isOpen = true;
		} else {
			this.isOpen = false;
		}
	}

	getMode() {
		return this.multi;
	}
	getHiddenOptions() {
		return this.control.options.slice(this.maxNumOfOptions, this.control.options.length);
	}

	isSelected(value) {
		return includes(this.value, value);
	}

	isHiddenOpen() {
		this.isOpen = !this.isOpen;

		if (!isEmpty(this.value) && includes(this.value, this.noneValue)) {
			this.setAnswer([]);
			this.value = [];
		} else {
			this.setAnswer([this.noneValue]);
			this.value = [this.noneValue];
		}

		if (!this.isOpen) {
			this.isOpen = true;
		}
		this.isOpen = true;
	}

	onToggle(value) {
		if (this.control.disabled) {
			return;
		}

		// when remove
		if (this.isSelected(value)) {
			this.remove(value);
			return;
		}
		// when add
		this.add(value);

		if (this.control.attributes.maxLength === 1) {
			this.isOpen = false;
		}
	}

	remove(value) {
		if (this.mode === this.radio) {
			this.setAnswer(null);
			this.value = '';
		}

		if (this.mode === this.multi) {
			let ans = filter(this.value, (o) => o !== value);
			ans = isEmpty(ans) ? null : ans;
			this.setAnswer(ans);
			this.value = ans;
		}
	}

	add(value) {
		this.isOpen = false;
		if (!this.value || this.value == this.noneValue) {
			this.value = [];
			this.setAnswer([]);
		}

		// wait for digest to finish so this.value will be properly fetched from Store
		setTimeout(() => {
			// do not setAnswer if conditions aren't met
			if (this.value.length >= this.control.attributes.maxLength || includes(this.value, value)) {
				return;
			}
			this.setAnswer([...this.value, value]);
			this.value = [...this.value, value];
		}, 0);
	}

	isShowMoreButton() {
		return true;
	}

	calcMaxNumOfOptions() {
		return this.control.options.length;
	}

	onTabExit() {
		this.isOpen = false;
	}
}
